import { ActivatedRoute } from "@angular/router";
import { first } from "rxjs/operators";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { CoreConfigService } from "../../../../../@core/services/config.service";

import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
} from "@angular/forms";

import Stepper from "bs-stepper";
import { GoogleService } from "../../../../../services/google.service";
import Swal from "sweetalert2";

import {
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";

import { CommunicationService } from "../../../../../services/communication.service";

@Component({
  selector: "app-auth-approve-payment",
  templateUrl: "./auth-approve-payment.component.html",
  styleUrls: ["./auth-approve-payment.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AuthApprovePaymentComponent implements OnInit {
  // Public OLD
  public coreConfig: any;
  public passwordTextType: boolean;
  public registerForm: UntypedFormGroup;
  public submitted = false;

  public token: string;
  public returnLink: string;
  public info;
  public loading;
  public members: any = {
    plans: [],
    max: [],
    credits: 10,
    totalMax: 10,
    price: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
  };
  public today = new Date();
  public pageAdvanced = 1;
  public totalMembers = 0;
  public MinMaxDPdata: NgbDateStruct;

  public dataForm: any = [];
  public dataPlanOrder: any = [];
  public formattedAddress: any = [];
  public registerFormValidation: any = [];
  public allFormIsValid: boolean = false;
  public loadingButton: boolean = false;

  // Private OLD
  private _unsubscribeAll: Subject<any>;

  // Public
  public contentHeader: object;
  public products;
  public locations;
  public selectLocation;
  public paymentPer;
  public cartList: any = [];
  public dependentCartList: any = [];
  public discountList: any = [];
  public totalPrice;
  public totalDiscount;

  public validAccountHolder = false;

  public order: any = [];

  public wishlist;

  public items = [{ itemId: "", itemName: "", itemQuantity: "", itemCost: "" }];

  public item = {
    itemName: "",
    itemQuantity: "",
    itemCost: "",
  };

  // Private
  private checkoutStepper: Stepper;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   * @param {CommunicationService} _communicationService
   * @param {EcommerceService} _ecommerceService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _route: ActivatedRoute,
    private _googleService: GoogleService,
    private _formBuilder: UntypedFormBuilder,
    private _communicationService: CommunicationService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid

    if (this.registerForm.status === "VALID") {
    }
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * On sendForm
   */
  switchLoading() {
    this.loadingButton = !this.loadingButton;
  }

  confirmPayment() {
    var question1 = <HTMLInputElement>document.getElementById("question1");
    var question2 = <HTMLInputElement>document.getElementById("question2");

    var order = {
      token: this.token,
    };

    let type: string = "primary";

    if (this.info.activeMethod) {
      Swal.fire({
        title: "Information sent!",
        html:
          "<div><p>You already have a registered active payment method.</p></div><div><p>Would you like to proceed to checkout with this method?</p></div><div><small>Payment Method: " +
          this.info.methodInfo.type +
          "</small><br><small>Last four digits: " +
          this.info.methodInfo.last4 +
          "</small></div>",
        text: "Payment Method",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Use Current Payment Method",
        cancelButtonText: "Add New Payment Method",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-primary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this._communicationService
            .confirmPayment(order, type)
            .then((result) => {
              switch (result) {
                case "failed":
                  Swal.fire({
                    title: "Payment Error",
                    icon: "error",

                    html: "Please register a new payment method and approve the payment again.",
                    showClass: { popup: "animate__animated animate__flipInX" },
                    showCancelButton: true,

                    cancelButtonText: "Cancel",
                    confirmButtonText: "Register",

                    customClass: {
                      cancelButton: "btn btn-secondary mr-1",
                      confirmButton: "btn btn-primary",
                    },
                  }).then((data) => {
                    if (data.isConfirmed == true) {
                      window.open('', "_self");
                    } else {
                      var reason = String(data.dismiss);

                      switch (reason) {
                        case "cancel":
                          var switchLoading = <HTMLInputElement>(
                            document.getElementById("switchLoading")
                          );
                          switchLoading.click();

                          break;

                        default:
                          break;
                      }
                    }
                  });
              }
              this.ngOnInit();
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          type = "new";
          this._communicationService.confirmPayment(order, type);
          window.open(this.info.url, "_self");
          this.ngOnInit();
        }
      });
    } else {
      type = "new";
      this._communicationService.confirmPayment(order, type);
      window.open(this.info.url, "_self");
      this.ngOnInit();
    }
    // this._communicationService.confirmPayment(order).then((result: any) => {
    //   switch (result.status) {
    //     case "pending":
    //       Swal.fire({
    //         title: "No payment method found",
    //         icon: "error",

    //         html: "Please register a new payment method and approve the payment again.",
    //         showClass: { popup: "animate__animated animate__flipInX" },
    //         showCancelButton: true,

    //         cancelButtonText: "Cancel",
    //         confirmButtonText: "Register",

    //         customClass: {
    //           cancelButton: "btn btn-secondary mr-1",
    //           confirmButton: "btn btn-primary",
    //         },
    //       }).then((data) => {
    //         if (data.isConfirmed == true) {
    //           window.open(result.url, "_self");
    //         } else {
    //           var reason = String(data.dismiss);

    //           switch (reason) {
    //             case "cancel":
    //               var switchLoading = <HTMLInputElement>(
    //                 document.getElementById("switchLoading")
    //               );
    //               switchLoading.click();

    //               break;

    //             default:
    //               break;
    //           }
    //         }
    //       });

    //       break;

    //     case "succeeded":
    //       location.reload();
    //       break;

    //     default:
    //       break;
    //   }
    // });
  }
  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loading = true;
    // get return url from route parameters or default to '/'
    this.token = this._route.snapshot.queryParams["token"] || "/";
    this.returnLink = String(window.location.href);

    this._communicationService
      .getPaymentByToken(this.token, this.returnLink)
      .pipe(first())
      .subscribe(
        (data) => {
          this.info = data;
          switch (this.info.status) {
            case "active":
            case "completed":
            case "due":
              this.loading = false;
              Swal.fire({
                title: "Congratulations!",
                text: "Your payment approval has been confirmed.",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then(function () {});
              break;
              

            case "pending":
              this.loading = false;

              this.info.instalments.forEach((element) => {
                if (element.dueDate != null) {
                  element.dueDate = new Date(element.dueDate);
                }
              });
              break;

            case "processing":
              this.loading = false;
              Swal.fire({
                title: "Processing!",
                text: "Your payment is being processed .",
                icon: "info",
              });
              break;

            default:
              this.loading = false;

              break;
          }
        },
        (error) => {
          this.loading = false;
        }
      );

    // Subscribe to config changes
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.coreConfig = config;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
